var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
  return ar;
};
import { useEffect, useRef } from 'react';
import useIsomorphicLayoutEffect from 'use-isomorphic-layout-effect';
import { ReactEffectType } from './types';
import { partition } from './utils';
import { executeEffect } from './useMachine';
export function useReactEffectActions(service) {
  var effectActionsRef = useRef([]);
  var layoutEffectActionsRef = useRef([]);
  useIsomorphicLayoutEffect(function () {
    var sub = service.subscribe(function (currentState) {
      var _a, _b;
      if (currentState.actions.length) {
        var reactEffectActions = currentState.actions.filter(function (action) {
          return typeof action.exec === 'function' && '__effect' in action.exec;
        });
        var _c = __read(partition(reactEffectActions, function (action) {
            return action.exec.__effect === ReactEffectType.Effect;
          }), 2),
          effectActions = _c[0],
          layoutEffectActions = _c[1];
        (_a = effectActionsRef.current).push.apply(_a, __spread(effectActions.map(function (effectAction) {
          return [effectAction, currentState];
        })));
        (_b = layoutEffectActionsRef.current).push.apply(_b, __spread(layoutEffectActions.map(function (layoutEffectAction) {
          return [layoutEffectAction, currentState];
        })));
      }
    });
    return function () {
      sub.unsubscribe();
    };
  }, []);
  // this is somewhat weird - this should always be flushed within useLayoutEffect
  // but we don't want to receive warnings about useLayoutEffect being used on the server
  // so we have to use `useIsomorphicLayoutEffect` to silence those warnings
  useIsomorphicLayoutEffect(function () {
    while (layoutEffectActionsRef.current.length) {
      var _a = __read(layoutEffectActionsRef.current.shift(), 2),
        layoutEffectAction = _a[0],
        effectState = _a[1];
      executeEffect(layoutEffectAction, effectState);
    }
  }); // https://github.com/davidkpiano/xstate/pull/1202#discussion_r429677773
  useEffect(function () {
    while (effectActionsRef.current.length) {
      var _a = __read(effectActionsRef.current.shift(), 2),
        effectAction = _a[0],
        effectState = _a[1];
      executeEffect(effectAction, effectState);
    }
  });
}